<template>
  <div>
    <div class="row mt-2">
      <div class="col-md-4">
        <ValidationProvider
          name="nombre"
          rules="required"
          v-slot="{ errors }"
          :custom-messages="{
            required: 'El nombre es obligatorio',
          }"
        >
          <base-input type="text" label="Nombre" placeholder="Nombre" v-model="currentBeneficiario.nombre"></base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-md-4">
        <ValidationProvider
          name="paterno"
          rules="required"
          v-slot="{ errors }"
          :custom-messages="{
            required: 'El apellido es obligatorio',
          }"
        >
          <base-input type="text" label="Paterno" placeholder="Paterno" v-model="currentBeneficiario.paterno"></base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-md-4">
        <ValidationProvider
          name="materno"
          rules="required"
          v-slot="{ errors }"
          :custom-messages="{
            required: 'El apellido es obligatorio',
          }"
        >
          <base-input type="text" label="Materno" placeholder="Materno" v-model="currentBeneficiario.materno"></base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="row mt-3" v-if="clausulaLfpiorpiId === 2 && currentBeneficiario.tipo_beneficiario === 1">
      <div class="col-md-4">
        <b-form-checkbox name="check-button-1" disabled checked="true">Beneficiario Controlador Directo</b-form-checkbox>
      </div>
    </div>

    <b-row
      class="mt-2 align-items-center"
      v-if="
        (clausulaLfpiorpiId === 3 && currentBeneficiario.tipo_beneficiario === 1) ||
        (clausulaCffId === 2 && currentBeneficiario.tipo_beneficiario === 2)
      "
    >
      <b-col md="4">
        <b-form-checkbox name="check-button-2" disabled checked="true">
          {{ porcentajeCapitalSocialText }}
        </b-form-checkbox>
      </b-col>
      <b-col md="4">
        <ValidationProvider
          name="porcentaje_capital"
          rules=""
          v-slot="{ errors }"
          :custom-messages="{
            required: 'Campo obligatorio',
          }"
        >
          <b-form-group label="Porcentaje" label-for="input-porcentaje">
            <b-form-input
              id="input-porcentaje"
              v-model="currentBeneficiario.porcentaje_capital_social"
              placeholder="Porcentaje"
              type="number"
              :disabled="false"
            ></b-form-input>
          </b-form-group>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
    </b-row>

    <b-row
      class="mt-2 align-items-center"
      v-if="
        ([5].includes(clausulaLfpiorpiId) && currentBeneficiario.tipo_beneficiario === 1) ||
        (clausulaCffId === 4 && currentBeneficiario.tipo_beneficiario === 2)
      "
    >
      <b-col md="4">
        <b-form-checkbox name="check-button-3" disabled checked="true">Cargo Directivo o de Administración</b-form-checkbox>
      </b-col>
      <b-col md="4">
        <ValidationProvider
          name="cargo"
          rules=""
          v-slot="{ errors }"
          :custom-messages="{
            required: 'Campo obligatorio',
          }"
        >
          <b-form-group label="Cargo" label-for="input-cargo">
            <b-form-input
              id="input-cargo"
              v-model="currentBeneficiario.cargo"
              placeholder="Cargo"
              :disabled="false"
            ></b-form-input>
          </b-form-group>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
    </b-row>

    <b-row class="mt-2 align-items-center" v-if="[4].includes(clausulaLfpiorpiId) && currentBeneficiario.tipo_beneficiario === 1">
      <b-col md="4">
        <b-form-checkbox name="check-button-4" disabled checked="true">Poder Efectivo de Control</b-form-checkbox>
      </b-col>
      <b-col md="4">
        <ValidationProvider
          name="causa"
          rules="required"
          v-slot="{ errors }"
          :custom-messages="{
            required: 'Campo obligatorio',
          }"
        >
          <b-form-group label="Causa" label-for="select-causa">
            <b-form-select
              id="select-causa"
              v-model="currentBeneficiario.poder_efectivo_control"
              :options="optionsCausaPoder"
            ></b-form-select>
          </b-form-group>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="d-flex justify-content-end">
        <b-button type="submit" class="btn-fill orange-btn">Guardar</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "ModalBeneficiario",

  props: {
    currentBeneficiario: { type: Object },
    clausulaLfpiorpiId: { type: Number },
    clausulaCffId: { type: Number },
  },

  data() {
    return {
      optionsCausaPoder: [
        { value: null, text: "Seleccione una opción" },
        { value: 1, text: "Impone decisiones en Asambleas" },
        { value: 2, text: "Puede nombrar o destituir a los consejeros o administradores" },
        { value: 3, text: "Dirige la estrategia o principales políticas de la Persona Moral." },
      ],
      porcentajeCapitalSocialText:
        this.currentBeneficiario.tipo_beneficiario === 1
          ? "Tenedor de más del 25% del Capital Social"
          : "Tenedor de más del 15% del Capital Social",
    };
  },

  created() {},

  watch: {},

  methods: {},
};
</script>
